import { render, staticRenderFns } from "./Comingsoon_gas.vue?vue&type=template&id=72e4a9cc&scoped=true&"
import script from "./Comingsoon_gas.vue?vue&type=script&lang=js&"
export * from "./Comingsoon_gas.vue?vue&type=script&lang=js&"
import style0 from "./Comingsoon_gas.vue?vue&type=style&index=0&id=72e4a9cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e4a9cc",
  null
  
)

export default component.exports